import { REDUX_ACTION_TYPES } from './constants';
import {
  LegacyWorkflowVisitorCountData,
  SelectableItem,
  WorkflowId,
  WorkflowNodeTemplateId,
} from './types';

export const fetchThumbnails = (templateIds: WorkflowNodeTemplateId[]) =>
  ({
    type: REDUX_ACTION_TYPES.THUMBNAILS_FETCH_REQUESTED,
    templateIds,
  }) as const;

export const handleThumbnailFetchSuccess = (
  templateIds: WorkflowNodeTemplateId[],
  thumbnails: Record<WorkflowNodeTemplateId, string>,
) =>
  ({
    type: REDUX_ACTION_TYPES.THUMBNAILS_FETCH_SUCCEEDED,
    templateIds,
    thumbnails,
  }) as const;

export const handleThumbnailFetchFailure = (templateIds: WorkflowNodeTemplateId[]) =>
  ({
    type: REDUX_ACTION_TYPES.THUMBNAILS_FETCH_FAILED,
    templateIds,
  }) as const;

export const fetchSendActivity = (workflowIds: WorkflowId[]) =>
  ({
    type: REDUX_ACTION_TYPES.SEND_ACTIVITY_FETCH_REQUESTED,
    workflowIds,
  }) as const;

export const handleSendActivityFetchSuccess = (
  workflowIds: WorkflowNodeTemplateId[],
  sendActivity: Record<WorkflowId, LegacyWorkflowVisitorCountData>,
) =>
  ({
    type: REDUX_ACTION_TYPES.SEND_ACTIVITY_FETCH_SUCCEEDED,
    workflowIds,
    sendActivity,
  }) as const;

export const handleSendActivityFetchFailure = (workflowIds: WorkflowId[]) =>
  ({
    type: REDUX_ACTION_TYPES.SEND_ACTIVITY_FETCH_FAILED,
    workflowIds,
  }) as const;

export const toggleSelectionForItem = (item: SelectableItem) =>
  ({ type: REDUX_ACTION_TYPES.TOGGLE_SELECTION_FOR_ITEM, item }) as const;

export const selectItems = (items: SelectableItem[]) =>
  ({ type: REDUX_ACTION_TYPES.SELECT_ITEMS, items }) as const;

export const deselectAllItems = () => ({ type: REDUX_ACTION_TYPES.DESELECT_ALL_ITEMS }) as const;
